<template>
  <header class="header">
    <div class="header-left">
      <span class="diamond-nums">
        <i class="diamond"></i>
        <span class="gem-nums">{{getGem}}</span>
      </span>
      <span class="user-id">ID: {{$bus.uid}}</span>
    </div>
    <div class="header-inner">
      <h1 class="header-title">{{$bus.transify['T_P_TITLE']}}</h1>
      <!-- todo countdown -->
      <countdown v-if="$bus.actInfo"></countdown>
    </div>
    <div class="header-right">
       <i class="rule-icon" @click="showRule"></i>
       <i class="history-icon" @click="showHistory"></i>
    </div>
  </header>
</template>

<script>
import countdown from '@/components/countdown'
export default {
  components: {
    countdown
  },
  computed: {
    getGem: {
      get () {
        return this.$bus.gems
      },
      set (val) {
        this.$bus.gems = val
      }
    }
  },
  methods: {
    showHistory () {
      this.$bus.history.show = true
      this.$bus.addGA('history', 'show')
    },
    showRule () {
      this.$bus.rule.show = true
      this.$bus.addGA('rule', 'show')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/animation.scss';
.header {
  width: 100%;
  @include px2res(height, 140);
  @include px2res(padding, 0, 42, 0, 27);
  text-align: center;
  position: relative;
  .header-left {
    position: absolute;
    line-height: 1;
    @include px2res(padding, 27, 0, 0);
    @include px2res(font-size, 36);
    @include flexrc;
    flex-direction: column;
    align-items: flex-end;
    .user-id {
      @include px2res(font-size, 24);
    }
    .diamond-nums {
      white-space: nowrap;
      .diamond {
        float: left;
        @include px2res(width, 30);
        @include px2res(height, 26);
        @include px2res(margin, 3, 11, 0, 0);
      }
    }
  }
  .header-inner {
    width: 100%;
    @include flexrc;
    flex-wrap: wrap;
    flex-direction: column;
    .header-title {
      @include px2res(font-size, 96);
      @include px2res(height, 88);
      @include px2res(letter-spacing, 2);
      line-height: 1;
      font-weight: 700;
      color: #FFE167;
      text-shadow: 0px 0px 20px rgba(157, 54, 37, 1);
      animation: header-twinkle .8s ease-in infinite alternate;
    }
  }
  .header-right {
    position: absolute;
    @include flexrc;
    @include px2res(right, 42);
    @include px2res(top, 17);
    @include px2res(width, 162);
    .rule-icon {
      float: left;
      @include px2res(width, 74);
      @include px2res(height, 74);
      @include px2res(margin-right, 6);
    }
    .history-icon {
      float: left;
      @include px2res(width, 82);
      @include px2res(height, 74);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Header.vue